<p-accordion>
	<p-accordionTab>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'info-circle']" class="me-4" size="lg"></fa-icon>
			Venue Status
		</ng-template>
		<app-dealer-venue-status [venueSelected]="venueSelected"></app-dealer-venue-status>
	</p-accordionTab>
	<p-accordionTab [selected]="true">
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'cog']" class="me-4" size="lg"></fa-icon>
			POS Configuration Files
		</ng-template>
		<div class="d-flex">
			<span class="p-float-label mt-4 w-100">
				<p-dropdown
					#posConfigurationArchive
					[options]="venueService.storeConfigList.value"
					optionLabel="label"
					optionValue="value"
					name="posConfigurationArchive"
					[(ngModel)]="selectedPosConfigKey"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(venueService.storeConfigList.value)"
				></p-dropdown>
				<label for="posConfigurationArchive">POS Configuration Archive</label>
			</span>
			<p-button pRipple styleClass="p-button-raised p-button-success mt-4 mx-2" (click)="onDownloadPosConfigArchive(selectedPosConfigKey)">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'cloud-download']" size="lg" class="ms-1 me-2"></fa-icon>
						Download
					</div>
				</ng-template>
			</p-button>
		</div>
	</p-accordionTab>
	<p-accordionTab>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'link']" class="me-4" size="lg"></fa-icon>
			FocusLink Logs
		</ng-template>
		<span class="p-float-label mt-4 w-100">
			<p-dropdown
				#posConfigurationArchive
				[options]="venueService.storeLinkLogList.value"
				optionLabel="label"
				optionValue="value"
				name="posConfigurationArchive"
				[(ngModel)]="selectedPosLinkLogKey"
				[style]="{ width: '100%' }"
				appendTo="body"
				[autoDisplayFirst]="false"
				[virtualScroll]="true"
				virtualScrollItemSize="30"
				filter="true"
				(filterBy)="app.keys(venueService.storeConfigList.value)"
			></p-dropdown>
			<label for="posConfigurationArchive">FocusLink Log File</label>
		</span>
		<p-button pRipple styleClass="p-button-raised p-button-success mt-4 mx-2" (click)="onDownloadPosConfigArchive(selectedPosLinkLogKey)">
			<ng-template pTemplate="content">
				<div class="d-flex justify-content-center">
					<fa-icon [icon]="['far', 'cloud-download']" size="lg" class="ms-1 me-2"></fa-icon>
					Download
				</div>
			</ng-template>
		</p-button>
	</p-accordionTab>
	<p-accordionTab>
		<ng-template pTemplate="header">
			<fa-icon [icon]="['far', 'power-off']" class="me-4" size="lg"></fa-icon>
			Venue Control
		</ng-template>
		<div class="d-flex">
			<span class="p-float-label mt-4 flex-fill">
				<p-dropdown
					#venueStationSelect
					[options]="venueSelected.status.stationStatus"
					optionLabel="name"
					optionValue="deviceId"
					name="venueStationSelect"
					[(ngModel)]="selectedVenueDeviceId"
					[style]="{ width: '100%' }"
					appendTo="body"
					[autoDisplayFirst]="false"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					filter="true"
					(filterBy)="app.keys(venueSelected.status.stationStatus)"
				></p-dropdown>
				<label for="venueStationSelect">Device</label>
			</span>
			<p-button pRipple styleClass="p-button-raised p-button-warning mx-2 mt-4" (click)="onDeviceSoftwareRestart()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'recycle']" size="lg" class="ms-1 me-2"></fa-icon>
						Restart Focus
					</div>
				</ng-template>
			</p-button>
			<p-button pRipple styleClass="p-button-raised p-button-danger mx-2 mt-4" (click)="onDeviceReboot()">
				<ng-template pTemplate="content">
					<div class="d-flex justify-content-center">
						<fa-icon [icon]="['far', 'power-off']" size="lg" class="ms-1 me-2"></fa-icon>
						Reboot
					</div>
				</ng-template>
			</p-button>
		</div>
	</p-accordionTab>
</p-accordion>
